interface Props {
  searchQuery: string;
  onSearchChange: (val: string) => void;
  activeCategory: string;
  onCategoryChange: (cat: string) => void;
  categories: string[];
  totalCount: number;
}

export default function MamaApprovedHero({
  searchQuery,
  onSearchChange,
  activeCategory,
  onCategoryChange,
  categories,
  totalCount,
}: Props) {
  return (
    <section className="relative pt-32 pb-16 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/05cf9d6880292b5b2d5ccf5e5663a5af.jpg"
          alt="Mama Approved hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-pink-900/75 via-rose-800/65 to-amber-900/60" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-amber-400/20 border border-amber-300/40 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
          <i className="ri-medal-fill text-amber-300 text-base"></i>
          <span className="text-amber-200 text-xs font-bold tracking-widest uppercase">Community Vetted</span>
        </div>

        <h1 className="text-5xl md:text-6xl font-extrabold text-white leading-tight mb-5">
          Mama Approved
          <span className="block text-amber-300">Businesses</span>
        </h1>

        <p className="text-white/85 text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          Every business here has been personally vetted and recommended by moms in the Mommy Mingle community. Shop, book, and trust with confidence.
        </p>

        <div className="max-w-xl mx-auto mb-8">
          <div className="relative">
            <div className="w-5 h-5 flex items-center justify-center absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
              <i className="ri-search-line text-lg"></i>
            </div>
            <input
              type="text"
              placeholder="Search businesses..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full pl-11 pr-4 py-3.5 rounded-full bg-white/95 backdrop-blur-sm text-gray-800 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-amber-400 shadow-lg"
            />
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-6">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => onCategoryChange(cat)}
              className={`px-4 py-2 rounded-full text-xs font-semibold transition-all whitespace-nowrap cursor-pointer ${
                activeCategory === cat
                  ? 'bg-amber-400 text-gray-900 shadow-md'
                  : 'bg-white/20 text-white border border-white/30 hover:bg-white/30 backdrop-blur-sm'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <p className="text-white/60 text-sm">
          Showing <span className="text-amber-300 font-bold">{totalCount}</span> Mama Approved businesses
        </p>
      </div>
    </section>
  );
}
